import React from 'react';
import Grid from '../layout/grid';

export default props => {
	return (
		<Grid cols={props.cols} style={{ minWidth: 220, maxWidth: 220 }}>
			<div className='form-group' style={{ marginBottom: props.marginBottom }}>
				{props.label && (
					<label htmlFor={props.name}>{props.label}</label>
				)}
				<input
					{...props.input}
					className='form-control'
					style={{ fontSize: props.fontSize }}
					placeholder={props.placeholder}
					readOnly={props.readOnly}
					type='datetime-local'
					value={props.value ? props.value.replace(' ', 'T').substring(0, 16) : ''}
					onChange={e =>
						props.onChange(
							e.target.value ? e.target.value.replace('T', ' ') + ':00' : null
						)
					}
				/>
			</div>
		</Grid>
	);
};
